import React from 'react'
import * as c from '../const'
import * as Yup from 'yup'
import {Formik, Form, Field} from 'formik'
import {useNavigate} from 'react-router-dom'
import {apiPost} from '../api/client'
import {TENANTS_ENDPOINTS} from '../api/endpoints'
import FormField from '../components/form/FormField'

function Home() {
  const navigate = useNavigate()

  const initialValues = {
    firstName: ``,
    lastName: ``,
    phoneNumber: ``,
    email: ``,
    companyName: ``,
    registrationKey: ``,
    terms: false
  }

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    phoneNumber: Yup.string()
      .required('Phone number is required')
      .matches(/^\+?[1-9]\d{1,14}$/, 'Phone number is not valid')
      .test(
        'len',
        'Phone number must be between 10 and 15 digits',
        (val) => val && val.replace(/\D/g, '').length >= 10 && val.replace(/\D/g, '').length <= 15),
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),
    companyName: Yup.string().required('Company name is required'),
    registrationKey: Yup.string().required('Registration key is required'),
    terms: Yup.boolean().oneOf([true], 'You must accept the terms and conditions')
  })

  const onSubmit = () => async (values, {setSubmitting, validateForm}) => {
    validateForm().then(async (errors) => {
      if (Object.keys(errors).length === 0) {
        try {
          // Extract the required fields for the API call
          const {firstName, lastName, phoneNumber, email, companyName, registrationKey} = values
          // Make the API call
          // eslint-disable-next-line no-unused-vars
          const response = await apiPost(TENANTS_ENDPOINTS.REGISTER_TENANT, {
            firstName, lastName, phone: phoneNumber, email, companyName, registrationKey
          })
          alert('Registration successful')
          navigate(c.LINK_THANK_YOU)
        } catch (error) {
          const errorMsg = error?.response?.data?.message || error?.message
          console.error('Error registering tenant: ', error)
          alert('Error registering tenant:' + errorMsg)
        }
      } else {
        console.log('Validation errors', errors)
      }
      setSubmitting(false)
    })
  }

  function RegistrationForm() {
    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit()}
      >
        {({handleSubmit, values, isSubmitting}) => {
          const isDisabled = isSubmitting || !values.terms

          const FIELDS = [
            {id: `firstName`,       name: `firstName`,       placeholder: `First name`, group: `first`},
            {id: `lastName`,        name: `lastName`,        placeholder: `Last name`,  group: `first`},
            {id: `phoneNumber`,     name: `phoneNumber`,     placeholder: `+1-212-456-7890`},
            {id: `email`,           name: `email`,           placeholder: `name@example.com`, type: `email`},
            {id: `companyName`,     name: `companyName`,     placeholder: `Company name`},
            {id: `registrationKey`, name: `registrationKey`, placeholder: `Registration key *`},
          ]

          const RenderField = (field) => {
            return (
              <FormField key={field?.id} {...field} />
            )
          }

          const groupedFields = FIELDS.reduce((acc, field) => {
            const group = field.group || `unique-${field?.id}`
            if (!acc[group]) {
              acc[group] = []
            }
            acc[group].push(field)
            return acc
          }, {})

          return (
            <Form className={`col-sta-cen maw-col-5 gap-3`} onSubmit={handleSubmit}>
              <div className={`col-sta-cen gap-1x5`}>
                {Object.entries(groupedFields).map(([group, fields]) => {
                  return fields.length === 1
                    ? RenderField(fields[0])
                    : (
                      <div key={group} className={`grid-flex --default row-2 m-xl-row-1`}>
                        {fields.map(RenderField)}
                      </div>
                    )
                })}

                <div className="form-choice">
                  <Field
                    id={`terms`}
                    type={`checkbox`}
                    name={`terms`}
                  />
                  <label htmlFor={`terms`} className={`form-choice-label`}>
                    <span className={`form-choice-icon`} />
                    <span className={`form-choice-text`}>
                      By creating an account, you agree to our
                      {` `}
                      <a href={c.LINK_TERMS_OF_USE} target={`_blank`}>Terms of Use</a>
                      {` `}
                      and
                      {` `}
                      <a href={c.LINK_PRIVACY_POLICY} target={`_blank`}>Privacy Policy</a>
                      .
                    </span>
                  </label>
                </div>
              </div>

              <button
                className={`btn-primary --std`}
                type={isDisabled ? `button` : `submit`}
                disabled={isDisabled}
              >
                Register now
              </button>

              <div
                className={`fg-pale w-full text-center`}
                style={{color: `#88888A`, fontSize: `15px`, maxWidth: `484px`}}
              >
                * You should have received your software registration key by e-mail.
                If you did not receive it, please contact your vending machine seller.
              </div>
            </Form>
          )
        }}
      </Formik>
    )
  }

  return (
    <div className={`content-width col-sta-cen w-full gap-2`}>
      <div className={`col-sta-cen w-full gap-0x5`}>
        <div className={`brand-h1`}>
          Register your vending software
        </div>
        <p className={`font-p`}>
          This will start your vending machine setup
        </p>
      </div>
      <RegistrationForm/>
    </div>
  )
}

export default Home
